import React from "react";
import "./Plans.css";

import { plansData } from "../../data/plansData";
import whiteTick from "../../assets/whiteTick.png";

const Plans = () => {
  return (
    <div className="plans-container">
      <div className="blur plans-blur-1"></div>
      <div className="blur plans-blur-2"></div>
      <div className="programs-header" style={{ gap: "2rem" }}>
        <span className="stroke-text">Ready to Star</span>
        <span>your journey</span>
        <span className="stroke-text">now wisthus</span>
      </div>
      {/* plan card */}
      <div className="plans">
        {plansData.map((plan, i) => (
          <div className="plan" key={i}>
            {plan.icon}
            <span>{plan.name}</span>
            <span>Rs. {plan.price}</span>
            <div className="features">
              {plan.features.map((feature, i) => (
                <div className="feature" key={i}>
                  <img src={whiteTick} alt="" />
                  <span>{feature}</span>
                </div>
              ))}
            </div>
            <div>
              <span>see more benefits = </span>
            </div>
            <button className="btn" ><a href="https://www.linkedin.com/in/aditya-pote11/">Join Now</a></button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Plans;
